import {mfaHeld} from '~/utils/mfa';
import {useAuthService} from "~/composables/useAuthService";
import {USER_FORM_PROMPT_EXITS} from "~/composables/useUserFormPrompts";
import {userTagWallDestination} from "~/utils/userTag";

/**
 * A signed-in member with no user tag is held at the user tag step
 * (PRIVACY_PLAN.md §15) until they choose one. Runs after accountSetup and
 * userFormPrompt (alphabetical), so the setup screen and a required form go
 * first; the rule itself also stands down while either is owed, so two walls
 * never fight over the route.
 *
 * THE BLOCKING IS THE ROUTE, for the same reason the form wall's is: a wall
 * drawn by a mounted component is a wall that a render error or a stray
 * navigation leaves a hole in. The exits are the form wall's (the legal
 * pages, contact, the profile page with delete and export, the one-click
 * email pages, the super console) plus the step itself.
 */
export default defineNuxtRouteMiddleware((to) => {
    const {isAuthenticated, user} = useAuthService();
    if (!isAuthenticated.value) return;
    // The two-step wall goes first and alone (utils/mfa.js mfaHeld).
    if (mfaHeld(user.value)) return;
    const destination = userTagWallDestination(to.fullPath, user.value, USER_FORM_PROMPT_EXITS);
    if (destination) return navigateTo(destination);
});
